var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsvDocumentSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "csv-document_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69125 0C3.94 0 2.52063 1.42 2.52063 3.17125V36.8219C2.52063 38.5737 3.94 39.9931 5.69125 39.9931H34.3C36.0506 39.9931 37.4713 38.5737 37.4713 36.8219V12.6937L25.6569 0L5.69125 0Z",
    fill: "#45B058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1912 26.9981C15.27 27.0881 15.315 27.2006 15.315 27.3243C15.315 27.5606 15.1237 27.7743 14.8756 27.7743C14.7631 27.7743 14.6394 27.7293 14.5606 27.6281C14.1219 27.0993 13.3787 26.7612 12.6812 26.7612C11.0381 26.7612 9.78937 28.0218 9.78937 29.8112C9.78937 31.5893 11.0387 32.8606 12.6812 32.8606C13.39 32.8606 14.0875 32.5568 14.5606 32.005C14.6387 31.915 14.7631 31.8593 14.8756 31.8593C15.135 31.8593 15.315 32.0837 15.315 32.3206C15.315 32.4331 15.27 32.5456 15.1912 32.6356C14.6056 33.2431 13.8069 33.6937 12.6819 33.6937C10.5212 33.6937 8.82187 32.1181 8.82187 29.8112C8.82187 27.5043 10.5212 25.9287 12.6819 25.9287C13.8069 25.9293 14.6169 26.3793 15.1912 26.9981ZM19.4425 33.6943C18.3287 33.6943 17.4506 33.3231 16.8094 32.76C16.7081 32.67 16.6631 32.5462 16.6631 32.4225C16.6631 32.1968 16.8319 31.9493 17.1019 31.9493C17.1919 31.9493 17.2931 31.9718 17.3719 32.0393C17.8894 32.5012 18.6094 32.8606 19.4762 32.8606C20.8156 32.8606 21.2431 32.1406 21.2431 31.5662C21.2431 29.6306 16.7981 30.7 16.7981 28.0212C16.7981 26.7837 17.9006 25.9393 19.375 25.9393C20.3425 25.9393 21.1756 26.2312 21.7831 26.7381C21.8844 26.8281 21.9406 26.9518 21.9406 27.0756C21.9406 27.3006 21.7494 27.5256 21.5012 27.5256C21.4112 27.5256 21.31 27.4918 21.2312 27.4243C20.68 26.9743 19.9937 26.7718 19.3069 26.7718C18.4069 26.7718 17.765 27.2556 17.765 27.965C17.765 29.6531 22.21 28.685 22.21 31.4875C22.2106 32.58 21.4681 33.6943 19.4425 33.6943ZM30.0637 26.6606L27.4644 33.12C27.3406 33.4237 27.0362 33.6262 26.7219 33.6262H26.6994C26.3731 33.6262 26.0694 33.4237 25.945 33.12L23.3562 26.6606C23.3337 26.6043 23.3225 26.5481 23.3225 26.4806C23.3225 26.2556 23.5244 25.985 23.8287 25.985C24.02 25.985 24.2 26.0975 24.2787 26.2887L26.7094 32.5337L29.14 26.2887C29.2075 26.1087 29.3875 25.985 29.59 25.985C29.8825 25.985 30.0962 26.2212 30.0962 26.4806C30.0969 26.5368 30.0856 26.6043 30.0637 26.6606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5006 12.7231V13.3481H29.5006C29.5006 13.3481 25.5556 12.5606 25.6706 9.15625C25.6706 9.15625 25.8006 12.7231 29.4225 12.7231H37.5006Z",
    fill: "#349C42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6862 0.00366211V9.10429C25.6862 10.1393 26.3762 12.7237 29.5012 12.7237H37.5012L25.6862 0.00366211Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvDocumentSvgrepocom);
export default __webpack_public_path__ + "static/media/csv-document_svgrepo.com.3a4d5c1d35c15e338a35a918b28b96af.svg";
export { ForwardRef as ReactComponent };